import getClosestNumberFromArray from "./getClosestNumberFromArray";

const RES_MAP = {
  1920: {
      12: 0.62,
      10: 0.62,
      9: 0.6,
      8: 2 / 3,
  },
  1440: {
      12: 1 / 2,
      10: 0.52,
      9: 0.525,
      8: 1 / 2,
      7: 0.525,
      6: 1 / 2,
  },
};

export default function (scoresCount) {
  const map = RES_MAP[getClosestNumberFromArray(window.innerWidth, Object.keys(RES_MAP))];
  return map ? (map[scoresCount] || 0) : 0;
}



// WEBPACK FOOTER //
// ./src/utils/getLeaderboardResFactor.js